import { useMeetingContext } from 'src/context/MeetingProvider';
import QuestionsScreen from './QuestionScreen';
import { useUserContext } from 'src/context/UserProvider';
import PreInterviewComponent from './PreInterviewComponent';
import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { CurrentWorkingStatus, MeetingType } from 'types';
import AIQuestionsScreen from './AIQuestionScreen';

const PleaseFillInTheRequiredDetails = () => {
	const queryClient = useQueryClient();

	useEffect(() => {
		const refetchMeetingDetails = setInterval(() => queryClient.refetchQueries(['getMeetingById']), 5000);

		return () => {
			clearInterval(refetchMeetingDetails);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="relative h-full w-full bg-[#1f2023] flex flex-col justify-center items-center">
			<div className=" max-h-full overflow-y-scroll flex flex-col justify-center items-center">
				<p className=" text-2xl font-bold ">
					Before beginning, answer a few details about your profile asked by the interviewer for a personalised
					interview experience.
				</p>
				<br />

				<div>
					<p className="text-lg">
						The purpose of these details is to define the difficulty and number of questions asked based on the current
						job market and tech stack you have selected.
					</p>
				</div>
			</div>
		</div>
	);
};

export const MeetingScreenWrapper = () => {
	const { isMentorLoggedIn, isJobseekerLoggedIn } = useUserContext();
	const { meeting, hasAssessmentEnded, ongoingAssessDetails } = useMeetingContext();
	const user = meeting?.participant;
	const isParticipantProfileIncomplete =
		!user?.profile.gradYear ||
		!user.profile.currentWorkingStatus ||
		(user.profile.currentWorkingStatus === CurrentWorkingStatus.Working && !user.profile.workExperiences?.length);

	if (!meeting) return null;
	// if (
	// 	(isMentorLoggedIn ||
	// 		((meeting.isAIInterview || meeting.meetingType === MeetingType.Assessment) && isJobseekerLoggedIn)) &&
	// 	isParticipantProfileIncomplete
	// )
	// 	return <PreInterviewComponent />;
	// if (isJobseekerLoggedIn && isParticipantProfileIncomplete) return <PleaseFillInTheRequiredDetails />;
	console.log(
		'!meeting.isAIInterview && meeting.meetingType !== MeetingType.Assessment',
		!meeting.isAIInterview && meeting.meetingType !== MeetingType.Assessment,
	);
	if (!meeting.isAIInterview && meeting.meetingType !== MeetingType.Assessment)
		return (
			<QuestionsScreen
				ongoingAssessDetails={ongoingAssessDetails}
				meeting={meeting}
				hasAssessmentEnded={hasAssessmentEnded}
			/>
		);
	return <AIQuestionsScreen />;
};
export default MeetingScreenWrapper;
